import {AccountFunction} from '../enums/account-function.enum';
import {
  ApplicationRole,
  BusinessRole,
} from '../enums/role.enum';

export const BUSINESS_ROLE_LABEL_KEYS: Record<BusinessRole, string> = {
  [BusinessRole.MEMBER]: 'front.sng.role.member',
  [BusinessRole.ENTRYPOINT_EMPLOYEE]: 'front.sng.role.entrypoint_employee',
  [BusinessRole.ENTRYPOINT_ADMIN]: 'front.sng.role.entrypoint_admin',
  [BusinessRole.BROKER_EMPLOYEE]: 'front.sng.role.broker_employee',
  [BusinessRole.BROKER_COMPANY]: 'front.sng.role.broker_company',
  [BusinessRole.INSURANCE_EMPLOYEE]: 'front.sng.role.insurance_employee',
  [BusinessRole.INSURANCE_COMPANY]: 'front.sng.role.insurance_company',
  [BusinessRole.REDUCED_ADMIN]: 'front.sng.role.reduced_admin',
};

export const USER_ROLE_LABEL_KEYS: Record<ApplicationRole | BusinessRole, string> = {
  ...BUSINESS_ROLE_LABEL_KEYS,
  [ApplicationRole.ADMIN]: 'front.sng.title.admin',
  [ApplicationRole.DEVELOPER]: 'front.sng.role.developer',
  [ApplicationRole.LIBRARY_ADMIN]: 'front.sng.role.library_admin',
  [ApplicationRole.GUEST]: 'front.sng.role.guest',
};

export const ACCOUNT_FUNCTION_LABEL_KEYS: Record<AccountFunction, string> = {
  [AccountFunction.BILL_RECEIVER]: 'front.sng.contact_persons.function_bill_receiver',
  [AccountFunction.MARKETING_MANAGER]: 'front.sng.contact_persons.function_marketing_manager',
  [AccountFunction.CEO]: 'front.sng.contact_persons.function_ceo',
  [AccountFunction.COO]: 'front.sng.contact_persons.function_coo',
  [AccountFunction.PROCESS_RESPONSIBLE]: 'front.sng.contact_persons.function_process_responsible',
  [AccountFunction.ENTRY_POINT]: 'front.sng.contact_persons.function_entry_point',
  [AccountFunction.MARKETPLACE]: 'front.sng.menu.marketplace',
  [AccountFunction.INVESTOR]: 'front.sng.contact_persons.function_investor',
};
